import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import API_BASE_URL from '../config';
import styles from '../css-isolated/filter_pdl.module.css';
import NotificationBell from './notification';
import ChangePasswordModal from './change_pass';
import authFetch from '../utils/authFetch';

function FilterPdl() {
  // Philippine Criminal Cases
  const philippineCriminalCases = [
    'Viol of Sec 5 RA 9165 (Sale of Dangerous Drugs)',
    'Viol of Sec 11 RA 9165 (Possession of Dangerous Drugs)',
    'Viol of Sec 5 and 11 RA 9165',
    'Viol of Sec 12 RA 9165 (Possession of Equipment/Paraphernalia)',
    'Viol of Sec 13 RA 9165 (Possession During Party)',
    'Viol of Sec 14 RA 9165 (Possession of Equipment/Instrument)',
    'Viol of Sec 15 RA 9165 (Use of Dangerous Drugs)',
    'Viol of Sec 16 RA 9165 (Cultivation/Culture of Dangerous Drugs)',
    'Viol of Sec 28 RA 10591 (Illegal Possession of Firearms)',
    'Viol of Sec 29 RA 10591 (Illegal Possession of Ammunition)',
    'Viol of RA 9262 (VAWC)',
    'Viol of Sec 5(a) RA 9262 (Physical Violence)',
    'Viol of Sec 5(e) RA 9262 (Economic Abuse)',
    'Viol of Sec 5(h) RA 9262 (Psychological Violence)',
    'Viol of RA 7610 (Child Abuse)',
    'Viol of Sec 10(a) RA 7610 (Child Abuse)',
    'Viol of RA 9344 (Juvenile Delinquency)',
    'Viol of RA 8049 (Hazing)',
    'Viol of BP 22 (Bouncing Checks)',
    'Murder (Art 248 RPC)',
    'Homicide (Art 249 RPC)',
    'Parricide (Art 246 RPC)',
    'Infanticide (Art 255 RPC)',
    'Frustrated Murder (Art 248 RPC)',
    'Frustrated Homicide (Art 249 RPC)',
    'Physical Injuries (Art 263 RPC)',
    'Serious Physical Injuries (Art 263 RPC)',
    'Less Serious Physical Injuries (Art 265 RPC)',
    'Slight Physical Injuries (Art 266 RPC)',
    'Rape (Art 266-A RPC)',
    'Rape by Sexual Assault (Art 266-A RPC)',
    'Acts of Lasciviousness (Art 336 RPC)',
    'Qualified Rape',
    'Robbery (Art 293 RPC)',
    'Robbery with Homicide (Art 294 RPC)',
    'Robbery with Rape (Art 294 RPC)',
    'Robbery with Physical Injuries (Art 294 RPC)',
    'Robbery in Band (Art 296 RPC)',
    'Theft (Art 308 RPC)',
    'Qualified Theft (Art 310 RPC)',
    'Estafa (Art 315 RPC)',
    'Syndicated Estafa',
    'Kidnapping (Art 267 RPC)',
    'Kidnapping for Ransom (Art 267 RPC)',
    'Illegal Detention (Art 267 RPC)',
    'Serious Illegal Detention (Art 267 RPC)',
    'Carnapping (RA 6539)',
    'Qualified Carnapping',
    'Arson (Art 320 RPC)',
    'Destructive Arson (PD 1613)',
    'Malicious Mischief (Art 327 RPC)',
    'Grave Threats (Art 282 RPC)',
    'Light Threats (Art 285 RPC)',
    'Grave Coercion (Art 286 RPC)',
    'Unjust Vexation (Art 287 RPC)',
    'Trespassing to Dwelling (Art 280 RPC)',
    'Qualified Trespassing (Art 280 RPC)',
    'Alarm and Scandal (Art 155 RPC)',
    'Falsification of Public Documents (Art 171 RPC)',
    'Falsification of Private Documents (Art 172 RPC)',
    'Use of Falsified Documents (Art 172 RPC)',
    'Perjury (Art 183 RPC)',
    'Libel (Art 353 RPC)',
    'Oral Defamation/Slander (Art 358 RPC)',
    'Grave Slander (Art 358 RPC)',
    'Slight Slander (Art 358 RPC)',
    'Bigamy (Art 349 RPC)',
    'Adultery (Art 333 RPC)',
    'Concubinage (Art 334 RPC)',
    'Seduction (Art 337 RPC)',
    'Qualified Seduction (Art 337 RPC)',
    'Abduction (Art 342 RPC)',
    'Direct Assault (Art 148 RPC)',
    'Indirect Assault (Art 149 RPC)',
    'Resistance and Disobedience (Art 151 RPC)',
    'Tumults and Other Disturbances (Art 153 RPC)',
    'Unlawful Arrest (Art 269 RPC)',
    'Arbitrary Detention (Art 124 RPC)',
    'Bribery (Art 210 RPC)',
    'Corruption of Public Officials (Art 212 RPC)',
    'Swindling/Estafa (Art 315 RPC)',
    'Viol of RA 3019 (Graft and Corruption)',
    'Viol of Sec 3(e) RA 3019',
    'Drug Trafficking',
    'Maintaining a Drug Den (Sec 6 RA 9165)',
    'Viol of RA 10175 (Cybercrime)',
    'Cyberlibel (RA 10175)',
    'Online Sexual Exploitation',
    'Computer-Related Fraud',
    'Illegal Access',
    'Viol of RA 9208 (Human Trafficking)',
    'Qualified Trafficking in Persons',
    'Viol of RA 9775 (Child Pornography)',
    'Viol of RA 11313 (Gender-Based Sexual Harassment)',
    'Illegal Gambling (PD 1602)',
    'Illegal Recruitment (RA 8042)',
    'Qualified Illegal Recruitment',
    'Anti-Fencing Law (PD 1612)',
    'Vote Buying (RA 9369)',
    'Election Offense',
    'Cattle Rustling (PD 533)',
    'Illegal Logging (PD 705)',
    'Illegal Fishing (RA 8550)',
    'Wildlife Trafficking (RA 9147)',
    'Rebellion (Art 134 RPC)',
    'Sedition (Art 139 RPC)',
    'Inciting to Sedition (Art 142 RPC)',
    'Coup d\'Etat (Art 134-A RPC)',
    'Tax Evasion (NIRC)',
    'Smuggling (CMTA)',
    'Others'
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [remarksFilter, setRemarksFilter] = useState('not_archived');
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterType, setFilterType] = useState(() => location?.state?.filterType || 'healthCondition');
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isCaseOther, setIsCaseOther] = useState(false);
  const [isHealthConditionOther, setIsHealthConditionOther] = useState(false);
  
  // Location data states for address filter
  const [regions, setRegions] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [municipalities, setMunicipalities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedRegionCode, setSelectedRegionCode] = useState('');
  const [selectedProvinceCode, setSelectedProvinceCode] = useState('');
  const [countrySearch, setCountrySearch] = useState('');
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const countryDropdownRef = React.useRef(null);
  
  // Date picker modal states for date range
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [isStartDateModal, setIsStartDateModal] = useState(true);
  const [startModalMonth, setStartModalMonth] = useState('');
  const [startModalDay, setStartModalDay] = useState('');
  const [startModalYear, setStartModalYear] = useState('');
  const [startModalTextDate, setStartModalTextDate] = useState('');
  const [endModalMonth, setEndModalMonth] = useState('');
  const [endModalDay, setEndModalDay] = useState('');
  const [endModalYear, setEndModalYear] = useState('');
  const [endModalTextDate, setEndModalTextDate] = useState('');
  const [modalError, setModalError] = useState('');
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved === 'dark' || saved === null;
  });
  const [showThemeModal, setShowThemeModal] = useState(false);
  const [pendingTheme, setPendingTheme] = useState(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  
  const [searchData, setSearchData] = useState({
    value: location?.state?.recommendationValue || '',
    min: '',
    max: '',
    dateFrom: '',
    dateTo: '',
    country: '',
    region: '',
    province: '',
    municipality: ''
  });

  // Helper function to calculate age from date of birth
  const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth) return 'N/A';
    
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    
    if (isNaN(birthDate.getTime())) return 'N/A';
    
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return age >= 0 ? age : 'N/A';
  };

  // Helper function to capitalize names
  const capitalizeName = (name) => {
    if (!name) return 'N/A';
    return name
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  // Filtering logic
  const filteredResults = React.useMemo(() => {
    switch (remarksFilter) {
      case 'all':
        return searchResults;
      case 'Release':
      case 'Transfer':
      case 'Death':
        return searchResults.filter(r => (r.final_remarks || '').toLowerCase() === remarksFilter.toLowerCase());
      case 'not_archived':
      default:
        return searchResults.filter(r => !r.final_remarks);
    }
  }, [searchResults, remarksFilter]);

  // Sorting logic
  const sortedResults = React.useMemo(() => {
    if (!sortColumn) return filteredResults;

    const sorted = [...filteredResults].sort((a, b) => {
      let aValue, bValue;

      switch (sortColumn) {
        case 'cell':
          aValue = a.cell?.cell_no || '';
          bValue = b.cell?.cell_no || '';
          break;
        case 'lastName':
          aValue = a.last_name || '';
          bValue = b.last_name || '';
          break;
        case 'firstName':
          aValue = a.first_name || '';
          bValue = b.first_name || '';
          break;
        case 'middleName':
          aValue = a.middle_name || '';
          bValue = b.middle_name || '';
          break;
        case 'aka':
          aValue = a.alias_nickname || '';
          bValue = b.alias_nickname || '';
          break;
        case 'age':
          aValue = calculateAge(a.date_of_birth);
          bValue = calculateAge(b.date_of_birth);
          // Handle 'N/A' values - treat as very high number so they appear at the end
          aValue = aValue === 'N/A' ? 999999 : Number(aValue);
          bValue = bValue === 'N/A' ? 999999 : Number(bValue);
          // Direct numeric comparison for age
          return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
        default:
          return 0;
      }

      // String comparison
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
      if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    return sorted;
  }, [filteredResults, sortColumn, sortDirection]);

  // Handle column header click for sorting
  const handleSort = (column) => {
    if (sortColumn === column) {
      // Toggle sort direction if same column
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // Set new column and default to ascending
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  // Get tooltip text for column sorting
  const getSortTooltip = (column) => {
    if (sortColumn === column && sortDirection === 'asc') {
      return 'Sort Z to A';
    }
    return 'Sort A to Z';
  };

  // Render sort indicator
  const renderSortIndicator = (column) => {
    if (sortColumn !== column) {
      return (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ opacity: 0.3, marginLeft: '4px' }}>
          <path d="M7 10L12 5L17 10M7 14L12 19L17 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    }
    return sortDirection === 'asc' ? (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '4px' }}>
        <path d="M7 14L12 9L17 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ) : (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '4px' }}>
        <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCaseChange = (e) => {
    const { value } = e.target;
    if (value === 'Others') {
      setIsCaseOther(true);
      setSearchData((prev) => ({ ...prev, value: '' }));
    } else {
      setIsCaseOther(false);
      setSearchData((prev) => ({ ...prev, value }));
    }
  };

  const handleHealthConditionChange = (e) => {
    const { value } = e.target;
    if (value === 'Other') {
      setIsHealthConditionOther(true);
      setSearchData((prev) => ({ ...prev, value: '' }));
    } else {
      setIsHealthConditionOther(false);
      setSearchData((prev) => ({ ...prev, value }));
    }
  };

  // Location handlers for address filter
  const handleRegionChange = (e) => {
    const selectedName = e.target.value;
    const region = regions.find(r => r.name === selectedName);
    
    setSearchData(prev => ({
      ...prev,
      region: selectedName,
      province: '',
      municipality: ''
    }));
    
    if (region) {
      setSelectedRegionCode(region.code);
      authFetch(`https://psgc.gitlab.io/api/regions/${region.code}/provinces/`)
        .then(res => res.json())
        .then(data => {
          setProvinces(data || []);
          setMunicipalities([]);
        })
        .catch(err => console.error('Error fetching provinces:', err));
    } else {
      setProvinces([]);
      setMunicipalities([]);
    }
  };

  const handleProvinceChange = (e) => {
    const selectedName = e.target.value;
    const province = provinces.find(p => p.name === selectedName);
    
    setSearchData(prev => ({
      ...prev,
      province: selectedName,
      municipality: ''
    }));
    
    if (province) {
      setSelectedProvinceCode(province.code);
      authFetch(`https://psgc.gitlab.io/api/provinces/${province.code}/cities-municipalities/`)
        .then(res => res.json())
        .then(data => setMunicipalities(data || []))
        .catch(err => console.error('Error fetching municipalities:', err));
    } else {
      setMunicipalities([]);
    }
  };

  const handleMunicipalityChange = (e) => {
    setSearchData(prev => ({ ...prev, municipality: e.target.value }));
  };

  const handleCountrySearchChange = (e) => {
    const value = e.target.value;
    setCountrySearch(value);
    setShowCountryDropdown(true);
  };

  const handleCountrySelect = (country) => {
    setSearchData(prev => ({ ...prev, country }));
    setCountrySearch(country);
    setShowCountryDropdown(false);
  };

  const getFilteredCountries = () => {
    if (!countrySearch) return countries;
    return countries.filter(country =>
      country.toLowerCase().includes(countrySearch.toLowerCase())
    );
  };

  const handleFilterTypeSelect = (type) => {
    setFilterType(type);
    setSearchData({ value: '', min: '', max: '', dateFrom: '', dateTo: '', country: '', region: '', province: '', municipality: '' });
    setIsCaseOther(false);
    setCountrySearch('');
    setSelectedRegionCode('');
    setSelectedProvinceCode('');
    setProvinces([]);
    setMunicipalities([]);
    setShowFilterModal(false);
  };

  // Update time every second
  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Auto-load when navigated from dashboard KPI card with a recommendation value
  React.useEffect(() => {
    const recValue = location?.state?.recommendationValue;
    if (!recValue) return;
    const token = localStorage.getItem('token');
    setIsLoading(true);
    authFetch(`${API_BASE_URL}/api/hr-info/search-by-recommendation?recommendation=${encodeURIComponent(recValue)}`, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setSearchResults(data))
      .catch(err => console.error('Auto-load recommendation error:', err))
      .finally(() => setIsLoading(false));
  }, [location.state]);

  // Load user data from localStorage
  React.useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        setUserData(JSON.parse(storedUser));
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }
  }, []);

  // Fetch regions and countries on component mount
  React.useEffect(() => {
    authFetch('https://psgc.gitlab.io/api/regions/')
      .then(res => res.json())
      .then(data => setRegions(data || []))
      .catch(err => console.error('Error fetching regions:', err));

    // Use complete hardcoded list of all countries (195+)
    const allCountries = [
      'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda',
      'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain',
      'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
      'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei Darussalam',
      'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon',
      'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia',
      'Comoros', 'Congo', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic',
      'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt',
      'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia',
      'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana',
      'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti',
      'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland',
      'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati',
      'Korea, North', 'Korea, South', 'Kosovo', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia',
      'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg',
      'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands',
      'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia',
      'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal',
      'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Macedonia',
      'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea',
      'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania',
      'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia',
      'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe',
      'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore',
      'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Sudan',
      'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria',
      'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga',
      'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda',
      'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States of America',
      'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam',
      'Yemen', 'Zambia', 'Zimbabwe'
    ];
    setCountries(allCountries);
  }, []);

  // Close country dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (showCountryDropdown && countryDropdownRef.current && !countryDropdownRef.current.contains(event.target)) {
        setShowCountryDropdown(false);
      }
    };

    if (showCountryDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showCountryDropdown]);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    const currentTheme = localStorage.getItem('theme');
    localStorage.clear();
    sessionStorage.clear();
    if (currentTheme) {
      localStorage.setItem('theme', currentTheme);
    }
    setShowLogoutModal(false);
    navigate('/login', { replace: true });
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  const toggleDarkMode = (newMode) => {
    setPendingTheme(newMode);
    setShowThemeModal(true);
  };

  const confirmThemeChange = async () => {
    // Close modal immediately
    setShowThemeModal(false);
    
    // Update local state and storage
    setIsDarkMode(pendingTheme);
    localStorage.setItem('theme', pendingTheme ? 'dark' : 'light');
    
    try {
      // Update database in background
      if (userData && userData.id) {
        const response = await authFetch(`${API_BASE_URL}/api/update-theme`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_id: userData.id,
            is_darkmode: pendingTheme ? 1 : 0
          })
        });

        if (!response.ok) {
          console.error('Failed to update theme in database');
        }
      }
    } catch (error) {
      console.error('Error updating theme:', error);
    } finally {
      setPendingTheme(null);
    }
  };

  const cancelThemeChange = () => {
    setShowThemeModal(false);
    setPendingTheme(null);
  };

  const formatDate = (date) => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  // Helper function for date validation
  const getDaysInMonth = (month, year) => {
    if (!month || !year) return 31;
    const monthNum = parseInt(month);
    if (monthNum === 2) {
      const yearNum = parseInt(year);
      const isLeapYear = (yearNum % 4 === 0 && yearNum % 100 !== 0) || (yearNum % 400 === 0);
      return isLeapYear ? 29 : 28;
    }
    if ([4, 6, 9, 11].includes(monthNum)) return 30;
    return 31;
  };

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const openStartDateModal = () => {
    setIsStartDateModal(true);
    setIsDateModalOpen(true);
    setModalError('');
  };

  const openEndDateModal = () => {
    setIsStartDateModal(false);
    setIsDateModalOpen(true);
    setModalError('');
  };

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropdownOpen && !event.target.closest(`.${styles.profileSection}`)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleSearch = async (e) => {
    e.preventDefault();
    
    // Validate based on filter type
    if (filterType === 'bmi' || filterType === 'age') {
      const { min, max } = searchData;
      if (!min && !max) {
        setErrorMessage(`Enter ${filterType === 'bmi' ? 'BMI' : 'age'} min or max to search.`);
        setShowErrorModal(true);
        return;
      }
      if (min && max && parseFloat(min) > parseFloat(max)) {
        setErrorMessage(`Min ${filterType === 'bmi' ? 'BMI' : 'age'} must be less than or equal to Max ${filterType === 'bmi' ? 'BMI' : 'age'}.`);
        setShowErrorModal(true);
        return;
      }
    } else if (filterType === 'dateOfCommitment') {
      const { dateFrom, dateTo } = searchData;
      if (!dateFrom && !dateTo) {
        setErrorMessage('Enter start or end date to search.');
        setShowErrorModal(true);
        return;
      }
      if (dateFrom && dateTo && new Date(dateFrom) > new Date(dateTo)) {
        setErrorMessage('Start date must be before or equal to end date.');
        setShowErrorModal(true);
        return;
      }
    } else if (filterType === 'address') {
      const { country, region, province, municipality } = searchData;
      if (!country && !region && !province && !municipality) {
        setErrorMessage('Please select at least one address field to search.');
        setShowErrorModal(true);
        return;
      }
    } else {
      if (!searchData.value) {
        setErrorMessage('Please enter a search value');
        setShowErrorModal(true);
        return;
      }
    }
    
    setIsLoading(true);
    
    try {
      const token = localStorage.getItem('token');
      let url;
      if (filterType === 'bmi') {
        const params = new URLSearchParams();
        if (searchData.min) params.append('min', searchData.min);
        if (searchData.max) params.append('max', searchData.max);
        url = `${API_BASE_URL}/api/hr-info/search-by-bmi?${params.toString()}`;
      } else if (filterType === 'age') {
        const params = new URLSearchParams();
        if (searchData.min) params.append('min', searchData.min);
        if (searchData.max) params.append('max', searchData.max);
        url = `${API_BASE_URL}/api/hr-info/search-by-age?${params.toString()}`;
      } else if (filterType === 'bloodPressure') {
        url = `${API_BASE_URL}/api/hr-info/search-by-blood-pressure?category=${encodeURIComponent(searchData.value)}`;
      } else if (filterType === 'drugHistory') {
        url = `${API_BASE_URL}/api/hr-info/search-by-drug-history?hasHistory=${encodeURIComponent(searchData.value)}`;
      } else if (filterType === 'smokingHistory') {
        url = `${API_BASE_URL}/api/hr-info/search-by-smoking-history?hasHistory=${encodeURIComponent(searchData.value)}`;
      } else if (filterType === 'alcoholHistory') {
        url = `${API_BASE_URL}/api/hr-info/search-by-alcohol-history?hasHistory=${encodeURIComponent(searchData.value)}`;
      } else if (filterType === 'sex') {
        url = `${API_BASE_URL}/api/hr-info/search-by-sex?sex=${encodeURIComponent(searchData.value)}`;
      } else if (filterType === 'civilStatus') {
        url = `${API_BASE_URL}/api/hr-info/search-by-civil-status?civilStatus=${encodeURIComponent(searchData.value)}`;
      } else if (filterType === 'education') {
        url = `${API_BASE_URL}/api/hr-info/search-by-education?education=${encodeURIComponent(searchData.value)}`;
      } else if (filterType === 'dateOfCommitment') {
        const params = new URLSearchParams();
        if (searchData.dateFrom) params.append('dateFrom', searchData.dateFrom);
        if (searchData.dateTo) params.append('dateTo', searchData.dateTo);
        url = `${API_BASE_URL}/api/hr-info/search-by-date-of-commitment?${params.toString()}`;
      } else if (filterType === 'bloodType') {
        url = `${API_BASE_URL}/api/hr-info/search-by-blood-type?bloodType=${encodeURIComponent(searchData.value)}`;
      } else if (filterType === 'bodyMark') {
        url = `${API_BASE_URL}/api/hr-info/search-by-body-mark?markType=${encodeURIComponent(searchData.value)}`;
      } else if (filterType === 'recommendation') {
        url = `${API_BASE_URL}/api/hr-info/search-by-recommendation?recommendation=${encodeURIComponent(searchData.value)}`;
      } else if (filterType === 'case') {
        url = `${API_BASE_URL}/api/hr-info/search-by-case?case=${encodeURIComponent(searchData.value)}`;
      } else if (filterType === 'address') {
        const params = new URLSearchParams();
        if (searchData.country) params.append('country', searchData.country);
        if (searchData.region) params.append('region', searchData.region);
        if (searchData.province) params.append('province', searchData.province);
        if (searchData.municipality) params.append('municipality', searchData.municipality);
        url = `${API_BASE_URL}/api/hr-info/search-by-address?${params.toString()}`;
      } else {
        url = `${API_BASE_URL}/api/hr-info/search-by-health?healthCondition=${encodeURIComponent(searchData.value)}`;
      }

      const response = await authFetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Search failed');
      }

      const data = await response.json();
      setSearchResults(data);
    } catch (error) {
      console.error('Search error:', error);
      setErrorMessage('Failed to search records. Please try again.');
      setShowErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={`${styles.systemApp} ${isDarkMode ? '' : styles.lightMode}`}>
      {/* System Header */}
      <header className={styles.systemHeader}>
        <div className={styles.headerLeft}>
          <div className={styles.systemLogo}>
            <img src="/BJMPRO-CAR.png" alt="BJMP CAR Logo" className={styles.systemLogoImg} />
            <div className={styles.systemTitle}>
              <h1>MediCast: BJMP Health Monitoring System</h1>
              <p>Bureau of Jail Management and Penology</p>
            </div>
          </div>
        </div>
        <div className={styles.headerRight}>
          <div className={styles.systemInfo}>
            <div className={styles.systemTime}>{currentTime.toLocaleTimeString()}</div>
            <div className={styles.systemUser}>{formatDate(currentTime)}</div>
          </div>
          <NotificationBell />
          <div className={styles.profileSection}>
            <div className={styles.profileIcon} onClick={toggleDropdown}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" fill="currentColor"/>
                <path d="M12 14C7.58172 14 4 17.5817 4 22H20C20 17.5817 16 14 12 14Z" fill="currentColor"/>
              </svg>
            </div>
            {isDropdownOpen && (
              <div className={styles.profileDropdown}>
                <div className={styles.dropdownHeader}>
                  <div className={styles.userInfo}>
                    <div className={styles.userRole}>
                      {userData?.user_type === 'unit_nurse' ? 'Unit Nurse' : 
                       userData?.user_type === 'chief_nurse' ? 'Chief Nurse' : 
                       userData?.user_type === 'warden' ? 'Warden' : 
                       userData?.user_type === 'admin' ? 'System Admin' : 
                       userData?.user_type === 'jail_officer' ? 'Jail Officer' : 'User'}
                    </div>
                    <div className={styles.userName}>
                      {userData ? 
                        `${userData.last_name ? userData.last_name.charAt(0).toUpperCase() + userData.last_name.slice(1).toLowerCase() : ''}, ${userData.first_name ? userData.first_name.charAt(0).toUpperCase() + userData.first_name.slice(1).toLowerCase() : ''} ${userData.middle_name ? userData.middle_name.charAt(0).toUpperCase() + userData.middle_name.slice(1).toLowerCase() : ''}`.trim() 
                        : 'User Name'}
                    </div>
                  </div>
                </div>
                <div className={styles.dropdownDivider}></div>
                <button className={styles.dropdownItem} onClick={() => toggleDarkMode(!isDarkMode)}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {isDarkMode ? (
                      <path d="M12 3V4M12 20V21M4 12H3M6.31412 6.31412L5.5 5.5M17.6859 6.31412L18.5 5.5M6.31412 17.69L5.5 18.5M17.6859 17.69L18.5 18.5M21 12H20M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    ) : (
                      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    )}
                  </svg>
                  {isDarkMode ? 'Light Mode' : 'Dark Mode'}
                </button>
                <button className={styles.dropdownItem} onClick={() => { setShowChangePasswordModal(true); setIsDropdownOpen(false); }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Change Password
                </button>
                <button className={styles.dropdownItem} onClick={handleLogout}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <polyline points="16,17 21,12 16,7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      <div className={styles.jbrSearchPage}>
        {/* Header with home button */}
        <div className={styles.jbrHeader}>
          <button onClick={() => navigate('/')} className={styles.jbrBackBtn}>← Back to Dashboard</button>
          <h1 className={styles.jbrTitle}>Filter by Health Condition</h1>
        </div>

        {/* Search Form */}
        <div className={styles.searchCard}>
          <div className={styles.searchHeader}>
            <div className={styles.searchHeaderIcon}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className={styles.searchHeaderText}>
              <h2>Search PDL Records</h2>
              <p>Select health condition to filter PDL records</p>
            </div>
          </div>
          
          <form onSubmit={handleSearch} className={styles.searchForm}>
            <div className={styles.searchFormGrid}>
              <div className={styles.inputGroup}>
                <div className={styles.inputIcon}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.5 12.75L6 11.25M6 11.25L7.5 9.75M6 11.25L4.5 9.75M6 11.25L7.5 12.75M10.5 3.75H18.5C19.0304 3.75 19.5391 3.96071 19.9142 4.33579C20.2893 4.71086 20.5 5.21957 20.5 5.75V18.25C20.5 18.7804 20.2893 19.2891 19.9142 19.6642C19.5391 20.0393 19.0304 20.25 18.5 20.25H10.5C9.96957 20.25 9.46086 20.0393 9.08579 19.6642C8.71071 19.2891 8.5 18.7804 8.5 18.25V5.75C8.5 5.21957 8.71071 4.71086 9.08579 4.33579C9.46086 3.96071 9.96957 3.75 10.5 3.75Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className={styles.inputWrapper}>
                  <label className={styles.inputLabel}>
                    {filterType === 'healthCondition' && 'Health Condition'}
                    {filterType === 'bmi' && 'BMI Range'}
                    {filterType === 'age' && 'Age Range'}
                    {filterType === 'bloodPressure' && 'Blood Pressure'}
                    {filterType === 'drugHistory' && 'Drug History'}
                    {filterType === 'smokingHistory' && 'Smoking History'}
                    {filterType === 'alcoholHistory' && 'Alcohol History'}
                    {filterType === 'sex' && 'Sex'}
                    {filterType === 'civilStatus' && 'Civil Status'}
                    {filterType === 'education' && 'Educational Attainment'}
                    {filterType === 'address' && 'Address'}
                    {filterType === 'dateOfCommitment' && 'Date of Commitment'}
                    {filterType === 'case' && 'Case'}
                    {filterType === 'bloodType' && 'Blood Type'}
                    {filterType === 'bodyMark' && 'Body Mark Type'}
                    {filterType === 'recommendation' && 'Recommendation'}
                  </label>
                  
                  {filterType === 'healthCondition' && !isHealthConditionOther && (
                    <select
                      name="value"
                      value={searchData.value}
                      onChange={handleHealthConditionChange}
                      className={styles.searchInput}
                    >
                      <option value="">Select Health Condition</option>
                      <option value="Healthy">Healthy</option>
                      <option value="Asthma">Asthma</option>
                      <option value="Cancer">Cancer</option>
                      <option value="Dengue">Dengue</option>
                      <option value="Diabetes">Diabetes</option>
                      <option value="Epilepsy">Epilepsy</option>
                      <option value="Heart Disease">Heart Disease</option>
                      <option value="Hepatitis A">Hepatitis A</option>
                      <option value="Hepatitis B">Hepatitis B</option>
                      <option value="Hepatitis C">Hepatitis C</option>
                      <option value="HIV/AIDS">HIV/AIDS</option>
                      <option value="Hypertension">Hypertension</option>
                      <option value="Kidney Disease">Kidney Disease</option>
                      <option value="Liver Disease">Liver Disease</option>
                      <option value="Pneumonia">Pneumonia</option>
                      <option value="Sexually Transmitted Infections">Sexually Transmitted Infections</option>
                      <option value="Tuberculosis">Tuberculosis</option>
                      <option value="Typhoid Fever">Typhoid Fever</option>
                      <option value="Other">Other</option>
                    </select>
                  )}

                  {filterType === 'healthCondition' && isHealthConditionOther && (
                    <div style={{ position: 'relative', width: '100%' }}>
                      <input
                        type="text"
                        name="value"
                        value={searchData.value}
                        onChange={handleInputChange}
                        className={styles.searchInput}
                        placeholder="Type health condition manually"
                        autoComplete="off"
                        autoFocus
                        style={{ paddingRight: '2.5rem', width: '100%' }}
                      />
                      <button
                        type="button"
                        onClick={() => {
                          setIsHealthConditionOther(false);
                          setSearchData((prev) => ({ ...prev, value: '' }));
                        }}
                        style={{
                          position: 'absolute',
                          right: '0.5rem',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          width: '1.5rem',
                          height: '1.5rem',
                          padding: '0',
                          background: 'rgba(239, 68, 68, 0.2)',
                          border: '1px solid rgba(239, 68, 68, 0.4)',
                          borderRadius: '0.25rem',
                          color: '#ef4444',
                          cursor: 'pointer',
                          fontSize: '1rem',
                          fontWeight: '700',
                          transition: 'all 0.3s ease',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          lineHeight: '1'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.background = 'rgba(239, 68, 68, 0.3)';
                          e.target.style.borderColor = 'rgba(239, 68, 68, 0.6)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.background = 'rgba(239, 68, 68, 0.2)';
                          e.target.style.borderColor = 'rgba(239, 68, 68, 0.4)';
                        }}
                      >
                        &times;
                      </button>
                    </div>
                  )}

                  {(filterType === 'bmi' || filterType === 'age') && (
                    <div className={styles.rangeInputs}>
                      <input
                        type="number"
                        name="min"
                        placeholder="Min"
                        className={styles.searchInput}
                        style={{ flex: 1 }}
                        value={searchData.min}
                        onChange={handleInputChange}
                      />
                      <span style={{ color: '#94a3b8', fontSize: '0.875rem' }}>to</span>
                      <input
                        type="number"
                        name="max"
                        placeholder="Max"
                        className={styles.searchInput}
                        style={{ flex: 1 }}
                        value={searchData.max}
                        onChange={handleInputChange}
                      />
                    </div>
                  )}

                  {(filterType === 'drugHistory' || filterType === 'smokingHistory' || filterType === 'alcoholHistory') && (
                    <select
                      name="value"
                      value={searchData.value}
                      onChange={handleInputChange}
                      className={styles.searchInput}
                    >
                      <option value="">Select</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  )}

                  {filterType === 'sex' && (
                    <select
                      name="value"
                      value={searchData.value}
                      onChange={handleInputChange}
                      className={styles.searchInput}
                    >
                      <option value="">Select Sex</option>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                    </select>
                  )}

                  {filterType === 'civilStatus' && (
                    <select
                      name="value"
                      value={searchData.value}
                      onChange={handleInputChange}
                      className={styles.searchInput}
                    >
                      <option value="">Select Civil Status</option>
                      <option value="Single">Single</option>
                      <option value="Married">Married</option>
                      <option value="Widowed">Widowed</option>
                      <option value="Separated">Separated</option>
                      <option value="Divorced">Divorced</option>
                      <option value="Live-in">Live-in</option>
                    </select>
                  )}

                  {filterType === 'education' && (
                    <select
                      name="value"
                      value={searchData.value}
                      onChange={handleInputChange}
                      className={styles.searchInput}
                    >
                      <option value="">Select Educational Attainment</option>
                      <option value="No Formal Education">No Formal Education</option>
                      <option value="Elementary Undergraduate">Elementary Undergraduate</option>
                      <option value="Elementary Graduate">Elementary Graduate</option>
                      <option value="High School Undergraduate">High School Undergraduate</option>
                      <option value="High School Graduate">High School Graduate</option>
                      <option value="Senior High School Undergraduate">Senior High School Undergraduate</option>
                      <option value="Senior High School Graduate">Senior High School Graduate</option>
                      <option value="Vocational/Technical Course">Vocational/Technical Course</option>
                      <option value="College Undergraduate">College Undergraduate</option>
                      <option value="College Graduate">College Graduate</option>
                      <option value="Post Graduate (Masters)">Post Graduate (Masters)</option>
                      <option value="Post Graduate (Doctorate)">Post Graduate (Doctorate)</option>
                    </select>
                  )}

                  {filterType === 'bloodType' && (
                    <select
                      name="value"
                      value={searchData.value}
                      onChange={handleInputChange}
                      className={styles.searchInput}
                    >
                      <option value="">Select Blood Type</option>
                      <option value="A+">A+</option>
                      <option value="A-">A-</option>
                      <option value="B+">B+</option>
                      <option value="B-">B-</option>
                      <option value="AB+">AB+</option>
                      <option value="AB-">AB-</option>
                      <option value="O+">O+</option>
                      <option value="O-">O-</option>
                    </select>
                  )}

                  {filterType === 'bodyMark' && (
                    <select
                      name="value"
                      value={searchData.value}
                      onChange={handleInputChange}
                      className={styles.searchInput}
                    >
                      <option value="">Select Body Mark Type</option>
                      <option value="tattoo">Tattoo</option>
                      <option value="piercing">Piercing</option>
                      <option value="scar">Scar</option>
                      <option value="burn">Burn</option>
                      <option value="bruise">Bruise</option>
                    </select>
                  )}

                  {filterType === 'recommendation' && (
                    <select
                      name="value"
                      value={searchData.value}
                      onChange={handleInputChange}
                      className={styles.searchInput}
                    >
                      <option value="">Select Recommendation</option>
                      <option value="dorm">General Dormitory</option>
                      <option value="isolated">Isolated</option>
                      <option value="hospitalized">Hospitalized</option>
                    </select>
                  )}

                  {filterType === 'address' && (
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', width: '100%' }}>
                      <div ref={countryDropdownRef}>
                        <label className={styles.inputLabel}>Country</label>
                        <input
                          type="text"
                          value={countrySearch}
                          onChange={handleCountrySearchChange}
                          onFocus={() => setShowCountryDropdown(true)}
                          onKeyDown={(e) => {
                            if (e.key === 'Escape') {
                              setShowCountryDropdown(false);
                            }
                          }}
                          className={styles.searchInput}
                          placeholder="Search country..."
                          autoComplete="off"
                        />
                        {showCountryDropdown && ReactDOM.createPortal(
                          <div
                            style={{
                              position: 'fixed',
                              top: countryDropdownRef.current?.getBoundingClientRect().bottom + 2,
                              left: countryDropdownRef.current?.getBoundingClientRect().left,
                              width: countryDropdownRef.current?.getBoundingClientRect().width,
                              maxHeight: '200px',
                              overflowY: 'auto',
                              background: '#1e293b',
                              border: '2px solid rgba(59, 130, 246, 0.3)',
                              borderRadius: '12px',
                              zIndex: 10000,
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
                            }}
                          >
                            {getFilteredCountries().length > 0 ? (
                              getFilteredCountries().map((country, index) => (
                                <div
                                  key={index}
                                  onMouseDown={(e) => {
                                    e.preventDefault();
                                    handleCountrySelect(country);
                                  }}
                                  style={{
                                    padding: '0.75rem 1rem',
                                    cursor: 'pointer',
                                    color: '#e2e8f0',
                                    background: searchData.country === country ? 'rgba(59, 130, 246, 0.3)' : 'transparent',
                                    transition: 'all 0.2s ease'
                                  }}
                                  onMouseEnter={(e) => e.target.style.background = 'rgba(59, 130, 246, 0.2)'}
                                  onMouseLeave={(e) => e.target.style.background = searchData.country === country ? 'rgba(59, 130, 246, 0.3)' : 'transparent'}
                                >
                                  {country}
                                </div>
                              ))
                            ) : (
                              <div style={{
                                padding: '0.75rem 1rem',
                                color: '#94a3b8',
                                textAlign: 'center'
                              }}>
                                No countries found
                              </div>
                            )}
                          </div>,
                          document.body
                        )}
                      </div>
                      <div>
                        <label className={styles.inputLabel}>Region</label>
                        <select
                          value={searchData.region}
                          onChange={handleRegionChange}
                          className={styles.searchInput}
                          disabled={searchData.country !== 'Philippines'}
                          title={searchData.country !== 'Philippines' ? 'Only available for Philippines' : ''}
                        >
                          <option value="">Select Region</option>
                          {searchData.country === 'Philippines' && regions.map((region, index) => (
                            <option key={index} value={region.name}>
                              {region.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className={styles.inputLabel}>Province</label>
                        <select
                          value={searchData.province}
                          onChange={handleProvinceChange}
                          className={styles.searchInput}
                          disabled={!selectedRegionCode || searchData.country !== 'Philippines'}
                          title={searchData.country !== 'Philippines' ? 'Only available for Philippines' : ''}
                        >
                          <option value="">Select Province</option>
                          {searchData.country === 'Philippines' && provinces.map((province, index) => (
                            <option key={index} value={province.name}>
                              {province.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className={styles.inputLabel}>Municipality/City</label>
                        <select
                          value={searchData.municipality}
                          onChange={handleMunicipalityChange}
                          className={styles.searchInput}
                          disabled={!selectedProvinceCode || searchData.country !== 'Philippines'}
                          title={searchData.country !== 'Philippines' ? 'Only available for Philippines' : ''}
                        >
                          <option value="">Select Municipality/City</option>
                          {searchData.country === 'Philippines' && municipalities.map((municipality, index) => (
                            <option key={index} value={municipality.name}>
                              {municipality.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}

                  {filterType === 'case' && !isCaseOther && (
                    <select
                      name="value"
                      value={searchData.value}
                      onChange={handleCaseChange}
                      className={styles.searchInput}
                    >
                      <option value="">Select Case</option>
                      {philippineCriminalCases.map((caseItem, index) => (
                        <option key={index} value={caseItem}>
                          {caseItem}
                        </option>
                      ))}
                    </select>
                  )}

                  {filterType === 'case' && isCaseOther && (
                    <div style={{ position: 'relative', width: '100%' }}>
                      <input
                        type="text"
                        name="value"
                        value={searchData.value}
                        onChange={handleInputChange}
                        className={styles.searchInput}
                        placeholder="Type case/offense manually"
                        autoComplete="off"
                        autoFocus
                        style={{ paddingRight: '2.5rem', width: '100%' }}
                      />
                      <button
                        type="button"
                        onClick={() => {
                          setIsCaseOther(false);
                          setSearchData((prev) => ({ ...prev, value: '' }));
                        }}
                        style={{
                          position: 'absolute',
                          right: '0.5rem',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          width: '1.5rem',
                          height: '1.5rem',
                          padding: '0',
                          background: 'rgba(239, 68, 68, 0.2)',
                          border: '1px solid rgba(239, 68, 68, 0.4)',
                          borderRadius: '0.25rem',
                          color: '#ef4444',
                          cursor: 'pointer',
                          fontSize: '1rem',
                          fontWeight: '700',
                          transition: 'all 0.3s ease',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          lineHeight: '1'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.background = 'rgba(239, 68, 68, 0.3)';
                          e.target.style.borderColor = 'rgba(239, 68, 68, 0.6)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.background = 'rgba(239, 68, 68, 0.2)';
                          e.target.style.borderColor = 'rgba(239, 68, 68, 0.4)';
                        }}
                      >
                        &times;
                      </button>
                    </div>
                  )}

                  {filterType === 'bloodPressure' && (
                    <select
                      name="value"
                      value={searchData.value}
                      onChange={handleInputChange}
                      className={styles.searchInput}
                    >
                      <option value="">Select Blood Pressure Category</option>
                      <option value="Normal">Normal Blood Pressure</option>
                      <option value="Low">Low Blood Pressure</option>
                      <option value="High">High Blood Pressure</option>
                    </select>
                  )}

                  {filterType === 'dateOfCommitment' && (
                    <div className={styles.rangeInputs}>
                      <input
                        type="text"
                        name="dateFrom"
                        className={styles.searchInput}
                        style={{ flex: 1, cursor: 'pointer' }}
                        value={searchData.dateFrom}
                        onClick={openStartDateModal}
                        placeholder="Start Date (YYYY-MM-DD)"
                        readOnly
                      />
                      <span style={{ color: '#94a3b8', fontSize: '0.875rem' }}>to</span>
                      <input
                        type="text"
                        name="dateTo"
                        className={styles.searchInput}
                        style={{ flex: 1, cursor: 'pointer' }}
                        value={searchData.dateTo}
                        onClick={openEndDateModal}
                        placeholder="End Date (YYYY-MM-DD)"
                        readOnly
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className={styles.searchActions}>
              <button 
                type="button" 
                className={styles.filterButton}
                onClick={() => setShowFilterModal(true)}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 4.5H21V6.5L14 14V20L10 22V14L3 6.5V4.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Advanced Filters
              </button>
              
              <div style={{ display: 'flex', gap: '1rem', marginLeft: 'auto' }}>
                <button type="submit" className={styles.searchButton} disabled={isLoading}>
                  {isLoading ? (
                    <>
                      <div className={styles.searchSpinner}></div>
                      Searching...
                    </>
                  ) : (
                    <>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      Search Records
                    </>
                  )}
                </button>
                
                <button 
                  type="button" 
                  className={styles.clearButton}
                  onClick={() => setSearchData({ value: '', min: '', max: '', dateFrom: '', dateTo: '' })}
                >
                  Clear
                </button>
              </div>
            </div>
          </form>
        </div>

        {/* Loading State */}
        {isLoading && (
          <div className={styles.resultsSection}>
            <div className={styles.resultsHeader}>
              <div className={styles.resultsHeaderIcon}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 11H15M9 15H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L19.7071 9.70711C19.8946 9.89464 20 10.149 20 10.4142V19C20 20.1046 19.1046 21 18 21H17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className={styles.resultsHeaderText}>
                <h3>Searching...</h3>
                <p>Please wait while we search for PDL records</p>
              </div>
            </div>
            <div className={styles.resultsContainer}>
              <div className={styles.loadingState}>
                <div className={styles.loadingSpinner}></div>
                <p>Searching PDL records...</p>
              </div>
            </div>
          </div>
        )}

        {/* Search Results */}
        {!isLoading && searchResults.length > 0 && (
          <div className={styles.resultsSection}>
            <div className={styles.resultsHeader}>
              <div className={styles.resultsHeaderIcon}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 11H15M9 15H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L19.7071 9.70711C19.8946 9.89464 20 10.149 20 10.4142V19C20 20.1046 19.1046 21 18 21H17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className={styles.resultsHeaderText}>
                <h3>Search Results</h3>
                <p>Showing {sortedResults.length} of {searchResults.length} record(s)</p>
              </div>
              <div style={{ marginLeft: 'auto', minWidth: '220px' }}>
                <select
                  className={styles.searchInput}
                  value={remarksFilter}
                  onChange={(e) => setRemarksFilter(e.target.value)}
                  style={{ marginTop: 0 }}
                >
                  <option value="not_archived">Not Archived (No Remarks)</option>
                  <option value="all">All (Archived + Not)</option>
                  <option value="Release">Release</option>
                  <option value="Transfer">Transfer</option>
                  <option value="Death">Death</option>
                </select>
              </div>
            </div>
            <div className={styles.resultsTableContainer}>
                <table className={styles.resultsTable}>
                  <thead>
                    <tr>
                      <th className={styles.tableHeader}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          Current Cell
                        </div>
                      </th>
                      <th className={styles.tableHeader} onClick={() => handleSort('lastName')} style={{ cursor: 'pointer', userSelect: 'none' }} title={getSortTooltip('lastName')}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          Last Name
                          {renderSortIndicator('lastName')}
                        </div>
                      </th>
                      <th className={styles.tableHeader} onClick={() => handleSort('firstName')} style={{ cursor: 'pointer', userSelect: 'none' }} title={getSortTooltip('firstName')}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          First Name
                          {renderSortIndicator('firstName')}
                        </div>
                      </th>
                      <th className={styles.tableHeader} onClick={() => handleSort('middleName')} style={{ cursor: 'pointer', userSelect: 'none' }} title={getSortTooltip('middleName')}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          Middle Name
                          {renderSortIndicator('middleName')}
                        </div>
                      </th>
                      <th className={styles.tableHeader} onClick={() => handleSort('aka')} style={{ cursor: 'pointer', userSelect: 'none' }} title={getSortTooltip('aka')}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          AKA
                          {renderSortIndicator('aka')}
                        </div>
                      </th>
                      <th className={styles.tableHeader} onClick={() => handleSort('age')} style={{ cursor: 'pointer', userSelect: 'none' }} title={getSortTooltip('age')}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          Age
                          {renderSortIndicator('age')}
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedResults.map((record, index) => (
                      <tr key={index} className={styles.tableRow}>
                        <td className={styles.tableCell}>
                          <span className={`${styles.cellBadge} ${record.cell ? styles.cellBadgeAssigned : styles.cellBadgeUnassigned}`}>
                            {record.cell?.cell_no || 'Unassigned'}
                          </span>
                        </td>
                        <td className={styles.tableCell}>
                          <span className={styles.cellText}>{capitalizeName(record.last_name)}</span>
                        </td>
                        <td className={styles.tableCell}>
                          <span className={styles.cellText}>{capitalizeName(record.first_name)}</span>
                        </td>
                        <td className={styles.tableCell}>
                          <span className={styles.cellText}>{capitalizeName(record.middle_name)}</span>
                        </td>
                        <td className={styles.tableCell}>
                          <span className={styles.cellText}>{capitalizeName(record.alias_nickname)}</span>
                        </td>
                        <td className={styles.tableCell}>
                          <span className={styles.cellText}>{calculateAge(record.date_of_birth)}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
          </div>
        )}

        {/* Empty State */}
        {!isLoading && searchResults.length === 0 && searchData.value === '' && (
          <div className={styles.emptyState}>
            <svg className={styles.emptyStateIcon} width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <h4>No Search Performed</h4>
            <p>Enter search criteria above to find PDL records</p>
          </div>
        )}

        {/* No Results */}
        {!isLoading && searchResults.length === 0 && searchData.value !== '' && (
          <div className={styles.emptyState}>
            <svg className={styles.emptyStateIcon} width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 10L14 14M14 10L10 14M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <h4>No Results Found</h4>
            <p>No PDL records match your search criteria. Try different search terms.</p>
          </div>
        )}
      </div>

      {/* Filter Modal */}
      {showFilterModal && (
        <div className={styles.modalOverlay} onClick={() => setShowFilterModal(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3>Select Filter Type</h3>
              <button className={styles.modalCloseBtn} onClick={() => setShowFilterModal(false)}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            <div className={styles.modalBody}>
              <div className={styles.filterButtonsGrid}>
                <button className={`${styles.filterTypeButton} ${filterType === 'healthCondition' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('healthCondition')}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.5 12.75L6 11.25M6 11.25L7.5 9.75M6 11.25L4.5 9.75M6 11.25L7.5 12.75M10.5 3.75H18.5C19.0304 3.75 19.5391 3.96071 19.9142 4.33579C20.2893 4.71086 20.5 5.21957 20.5 5.75V18.25C20.5 18.7804 20.2893 19.2891 19.9142 19.6642C19.5391 20.0393 19.0304 20.25 18.5 20.25H10.5C9.96957 20.25 9.46086 20.0393 9.08579 19.6642C8.71071 19.2891 8.5 18.7804 8.5 18.25V5.75C8.5 5.21957 8.71071 4.71086 9.08579 4.33579C9.46086 3.96071 9.96957 3.75 10.5 3.75Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Health Condition
                </button>
                <button className={`${styles.filterTypeButton} ${filterType === 'bmi' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('bmi')}>BMI</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'age' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('age')}>Age</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'bloodPressure' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('bloodPressure')}>Blood Pressure</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'drugHistory' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('drugHistory')}>Drug History</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'smokingHistory' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('smokingHistory')}>Smoking History</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'alcoholHistory' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('alcoholHistory')}>Alcohol History</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'sex' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('sex')}>Sex</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'civilStatus' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('civilStatus')}>Civil Status</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'education' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('education')}>Educational Attainment</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'address' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('address')}>Address</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'dateOfCommitment' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('dateOfCommitment')}>Date of Commitment</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'case' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('case')}>Case</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'bloodType' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('bloodType')}>Blood Type</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'bodyMark' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('bodyMark')}>Body Mark Type</button>
                <button className={`${styles.filterTypeButton} ${filterType === 'recommendation' ? styles.active : ''}`} onClick={() => handleFilterTypeSelect('recommendation')}>Recommendation</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Error Modal */}
      {showErrorModal && (
        <div className={styles.modalOverlay} onClick={() => setShowErrorModal(false)}>
          <div className={styles.errorModal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.errorIcon}>
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="12" y1="16" x2="12.01" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Validation Error</h3>
            <p>{errorMessage}</p>
            <button className={styles.errorBtn} onClick={() => setShowErrorModal(false)}>
              OK
            </button>
          </div>
        </div>
      )}

      {/* Date Picker Modal for Date Range */}
      {isDateModalOpen && (
        <div className={styles.datePickerOverlay} onClick={() => {
          setIsDateModalOpen(false);
          setModalError('');
        }}>
          <div className={styles.datePickerModal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.datePickerHeader}>
              <h3>📅 {isStartDateModal ? 'Select Start Date' : 'Select End Date'}</h3>
              <button 
                className={styles.datePickerCloseBtn}
                onClick={() => {
                  setIsDateModalOpen(false);
                  setModalError('');
                }}
              >
                &times;
              </button>
            </div>
            
            <div className={styles.datePickerContent}>
              <div className={styles.dateSelectionGrid}>
                <div className={styles.dateSelectGroup}>
                  <label className={styles.dateLabel}>Month</label>
                  <select 
                    className={styles.dateSelect}
                    value={isStartDateModal ? startModalMonth : endModalMonth}
                    onChange={(e) => {
                      const value = e.target.value;
                      setModalError('');
                      if (isStartDateModal) {
                        setStartModalMonth(value);
                        if (value && startModalDay && startModalYear) {
                          const m = value.padStart(2, '0');
                          const d = startModalDay.toString().padStart(2, '0');
                          setStartModalTextDate(`${m}/${d}/${startModalYear}`);
                        }
                        if (startModalDay && startModalYear && value) {
                          const maxDays = getDaysInMonth(value, startModalYear);
                          if (parseInt(startModalDay) > maxDays) {
                            setStartModalDay(String(maxDays));
                            const m = value.padStart(2, '0');
                            setStartModalTextDate(`${m}/${String(maxDays).padStart(2, '0')}/${startModalYear}`);
                          }
                        }
                      } else {
                        setEndModalMonth(value);
                        if (value && endModalDay && endModalYear) {
                          const m = value.padStart(2, '0');
                          const d = endModalDay.toString().padStart(2, '0');
                          setEndModalTextDate(`${m}/${d}/${endModalYear}`);
                        }
                        if (endModalDay && endModalYear && value) {
                          const maxDays = getDaysInMonth(value, endModalYear);
                          if (parseInt(endModalDay) > maxDays) {
                            setEndModalDay(String(maxDays));
                            const m = value.padStart(2, '0');
                            setEndModalTextDate(`${m}/${String(maxDays).padStart(2, '0')}/${endModalYear}`);
                          }
                        }
                      }
                    }}
                  >
                    <option value="">Month</option>
                    {monthNames.map((name, idx) => (
                      <option key={idx + 1} value={idx + 1}>{name}</option>
                    ))}
                  </select>
                </div>

                <div className={styles.dateSelectGroup}>
                  <label className={styles.dateLabel}>Day</label>
                  <select 
                    className={styles.dateSelect}
                    value={isStartDateModal ? startModalDay : endModalDay}
                    onChange={(e) => {
                      const value = e.target.value;
                      setModalError('');
                      if (isStartDateModal) {
                        setStartModalDay(value);
                        if (startModalMonth && value && startModalYear) {
                          const m = startModalMonth.toString().padStart(2, '0');
                          const d = value.padStart(2, '0');
                          setStartModalTextDate(`${m}/${d}/${startModalYear}`);
                        }
                      } else {
                        setEndModalDay(value);
                        if (endModalMonth && value && endModalYear) {
                          const m = endModalMonth.toString().padStart(2, '0');
                          const d = value.padStart(2, '0');
                          setEndModalTextDate(`${m}/${d}/${endModalYear}`);
                        }
                      }
                    }}
                    disabled={!(isStartDateModal ? startModalMonth : endModalMonth)}
                  >
                    <option value="">Day</option>
                    {Array.from({ 
                      length: getDaysInMonth(
                        isStartDateModal ? startModalMonth : endModalMonth, 
                        isStartDateModal ? startModalYear : endModalYear
                      ) 
                    }, (_, i) => i + 1).map(day => (
                      <option key={day} value={day}>{day}</option>
                    ))}
                  </select>
                </div>

                <div className={styles.dateSelectGroup}>
                  <label className={styles.dateLabel}>Year</label>
                  <select 
                    className={styles.dateSelect}
                    value={isStartDateModal ? startModalYear : endModalYear}
                    onChange={(e) => {
                      const value = e.target.value;
                      setModalError('');
                      if (isStartDateModal) {
                        setStartModalYear(value);
                        if (startModalMonth && startModalDay && value) {
                          const m = startModalMonth.toString().padStart(2, '0');
                          const d = startModalDay.toString().padStart(2, '0');
                          setStartModalTextDate(`${m}/${d}/${value}`);
                        }
                        if (startModalMonth && startModalDay) {
                          const maxDays = getDaysInMonth(startModalMonth, value);
                          if (parseInt(startModalDay) > maxDays) {
                            setStartModalDay(String(maxDays));
                            const m = startModalMonth.toString().padStart(2, '0');
                            setStartModalTextDate(`${m}/${String(maxDays).padStart(2, '0')}/${value}`);
                          }
                        }
                      } else {
                        setEndModalYear(value);
                        if (endModalMonth && endModalDay && value) {
                          const m = endModalMonth.toString().padStart(2, '0');
                          const d = endModalDay.toString().padStart(2, '0');
                          setEndModalTextDate(`${m}/${d}/${value}`);
                        }
                        if (endModalMonth && endModalDay) {
                          const maxDays = getDaysInMonth(endModalMonth, value);
                          if (parseInt(endModalDay) > maxDays) {
                            setEndModalDay(String(maxDays));
                            const m = endModalMonth.toString().padStart(2, '0');
                            setEndModalTextDate(`${m}/${String(maxDays).padStart(2, '0')}/${value}`);
                          }
                        }
                      }
                    }}
                  >
                    <option value="">Year</option>
                    {Array.from({ length: new Date().getFullYear() - 1900 + 1 }, (_, i) => new Date().getFullYear() - i).map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className={styles.modalRow}>
                <div className={styles.modalField} style={{ flex: 1 }}>
                  <label>Type Date (mm/dd/yyyy)</label>
                  <input
                    type="text"
                    className={styles.modalInput}
                    placeholder="mm/dd/yyyy"
                    value={isStartDateModal ? startModalTextDate : endModalTextDate}
                    onChange={(e) => {
                      let val = e.target.value;
                      const prevVal = isStartDateModal ? startModalTextDate : endModalTextDate;
                      
                      if (val.length < prevVal.length) {
                        if (isStartDateModal) setStartModalTextDate(val);
                        else setEndModalTextDate(val);
                        setModalError('');
                        return;
                      }
                      val = val.replace(/\D/g, '');
                      if (val.length >= 2) {
                        val = val.slice(0, 2) + '/' + val.slice(2);
                      }
                      if (val.length >= 5) {
                        val = val.slice(0, 5) + '/' + val.slice(5);
                      }
                      if (val.length > 10) {
                        val = val.slice(0, 10);
                      }
                      
                      if (isStartDateModal) setStartModalTextDate(val);
                      else setEndModalTextDate(val);
                      setModalError('');
                      
                      const parts = val.split('/');
                      if (parts[0] && parts[0].length === 2) {
                        const m = parseInt(parts[0]);
                        if (m >= 1 && m <= 12) {
                          if (isStartDateModal) setStartModalMonth(String(m));
                          else setEndModalMonth(String(m));
                        }
                      }
                      if (parts[1] && parts[1].length === 2) {
                        const d = parseInt(parts[1]);
                        const maxDays = getDaysInMonth(parts[0], parts[2]);
                        if (d >= 1 && d <= maxDays) {
                          if (isStartDateModal) setStartModalDay(String(d));
                          else setEndModalDay(String(d));
                        }
                      }
                      if (parts[2] && parts[2].length === 4) {
                        const y = parseInt(parts[2]);
                        const currentYear = new Date().getFullYear();
                        if (y <= currentYear) {
                          if (isStartDateModal) setStartModalYear(String(y));
                          else setEndModalYear(String(y));
                        }
                      }
                    }}
                    maxLength={10}
                  />
                </div>
              </div>

              {modalError && (
                <div className={styles.modalError}>
                  ⚠️ {modalError}
                </div>
              )}

              <div className={styles.modalHelper}>
                ℹ️ Select from dropdowns or type the date directly
              </div>
            </div>

            <div className={styles.datePickerActions}>
              <button 
                className={styles.datePickerClearBtn}
                onClick={() => {
                  setIsDateModalOpen(false);
                  if (isStartDateModal) {
                    setStartModalMonth('');
                    setStartModalDay('');
                    setStartModalYear('');
                    setStartModalTextDate('');
                  } else {
                    setEndModalMonth('');
                    setEndModalDay('');
                    setEndModalYear('');
                    setEndModalTextDate('');
                  }
                  setModalError('');
                }}
              >
                Cancel
              </button>
              <button 
                className={styles.datePickerConfirmBtn}
                disabled={isStartDateModal ? 
                  (!startModalMonth || !startModalDay || !startModalYear) : 
                  (!endModalMonth || !endModalDay || !endModalYear)
                }
                onClick={() => {
                  if (isStartDateModal) {
                    if (!startModalMonth || !startModalDay || !startModalYear) {
                      setModalError('Please select month, day, and year');
                      return;
                    }
                    const m = parseInt(startModalMonth);
                    const d = parseInt(startModalDay);
                    const y = parseInt(startModalYear);
                    if (m < 1 || m > 12) {
                      setModalError('Invalid month');
                      return;
                    }
                    const maxDays = getDaysInMonth(startModalMonth, startModalYear);
                    if (d < 1 || d > maxDays) {
                      setModalError(`Invalid day for selected month (max ${maxDays})`);
                      return;
                    }
                    const currentYear = new Date().getFullYear();
                    if (y > currentYear) {
                      setModalError(`Year cannot be greater than ${currentYear}`);
                      return;
                    }
                    const formattedMonth = startModalMonth.toString().padStart(2, '0');
                    const formattedDay = startModalDay.toString().padStart(2, '0');
                    const isoDate = `${startModalYear}-${formattedMonth}-${formattedDay}`;
                    setSearchData(prev => ({ ...prev, dateFrom: isoDate }));
                  } else {
                    if (!endModalMonth || !endModalDay || !endModalYear) {
                      setModalError('Please select month, day, and year');
                      return;
                    }
                    const m = parseInt(endModalMonth);
                    const d = parseInt(endModalDay);
                    const y = parseInt(endModalYear);
                    if (m < 1 || m > 12) {
                      setModalError('Invalid month');
                      return;
                    }
                    const maxDays = getDaysInMonth(endModalMonth, endModalYear);
                    if (d < 1 || d > maxDays) {
                      setModalError(`Invalid day for selected month (max ${maxDays})`);
                      return;
                    }
                    const currentYear = new Date().getFullYear();
                    if (y > currentYear) {
                      setModalError(`Year cannot be greater than ${currentYear}`);
                      return;
                    }
                    const formattedMonth = endModalMonth.toString().padStart(2, '0');
                    const formattedDay = endModalDay.toString().padStart(2, '0');
                    const isoDate = `${endModalYear}-${formattedMonth}-${formattedDay}`;
                    setSearchData(prev => ({ ...prev, dateTo: isoDate }));
                  }
                  setIsDateModalOpen(false);
                  setModalError('');
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Change Password Modal */}
      <ChangePasswordModal
        isOpen={showChangePasswordModal}
        onClose={() => setShowChangePasswordModal(false)}
        userData={userData}
        onSuccess={(message) => {
          setSuccessMessage(message || 'Password changed successfully');
          setShowSuccessModal(true);
        }}
        onError={(message) => {
          setErrorMessage(message);
          setShowErrorModal(true);
        }}
      />

      {/* Success Modal */}
      {showSuccessModal && (
        <div className={styles.modalOverlay} onClick={() => setShowSuccessModal(false)}>
          <div className={styles.successModal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.successIcon}>
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.7088 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Success</h3>
            <p>{successMessage}</p>
            <button className={styles.successBtn} onClick={() => setShowSuccessModal(false)}>
              OK
            </button>
          </div>
        </div>
      )}

      {/* Theme Change Confirmation Modal */}
      {showThemeModal && (
        <div className={styles.modalOverlay} onClick={cancelThemeChange}>
          <div className={styles.errorModal} onClick={(e) => e.stopPropagation()} style={{ borderColor: '#f59e0b' }}>
            <div className={styles.errorIcon} style={{ background: 'rgba(245, 158, 11, 0.1)', borderColor: 'rgba(245, 158, 11, 0.3)', color: '#f59e0b' }}>
              {pendingTheme ? (
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="currentColor"/>
                </svg>
              ) : (
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 3V4M12 20V21M4 12H3M6.31412 6.31412L5.5 5.5M17.6859 6.31412L18.5 5.5M6.31412 17.69L5.5 18.5M17.6859 17.69L18.5 18.5M21 12H20M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </div>
            <h3 style={{ color: '#f59e0b' }}>Change Theme</h3>
            <p>Are you sure you want to switch to <strong>{pendingTheme ? 'Dark' : 'Light'} Mode</strong>?</p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <button className={styles.cancelBtn} onClick={cancelThemeChange}>Cancel</button>
              <button className={styles.errorBtn} onClick={confirmThemeChange} style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' }}>Confirm</button>
            </div>
          </div>
        </div>
      )}

      {/* Logout Confirmation Modal */}
      {showLogoutModal && ReactDOM.createPortal(
        <div className={styles.modalOverlay} onClick={cancelLogout}>
          <div className={styles.errorModal} onClick={(e) => e.stopPropagation()} style={{ borderColor: '#ef4444' }}>
            <div className={styles.errorIcon} style={{ background: 'rgba(239, 68, 68, 0.1)', borderColor: 'rgba(239, 68, 68, 0.3)', color: '#ef4444' }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="16,17 21,12 16,7" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="21" y1="12" x2="9" y2="12" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 style={{ color: '#ef4444' }}>Logout</h3>
            <p>Are you sure you want to logout?</p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <button className={styles.cancelBtn} onClick={cancelLogout}>Cancel</button>
              <button className={styles.errorBtn} onClick={confirmLogout} style={{ background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' }}>Logout</button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}

export default FilterPdl;
